import { useQuery } from '@tanstack/react-query';
import apiClient from '../../lib/api';

export interface PhotoViewUrl {
  s3_key: string;
  view_url: string;
  error?: string;
}

/**
 * 写真・動画の閲覧用presigned URLを取得するカスタムフック
 * @param s3Keys S3キーの配列
 * @returns React Query の結果
 */
export const usePhotoViewUrls = (s3Keys: string[]) => {
  return useQuery<PhotoViewUrl[]>({
    queryKey: ['photoViewUrls', s3Keys],
    queryFn: async () => {
      if (s3Keys.length === 0) {
        return [];
      }
      const response = await apiClient.getMediaViewUrls(s3Keys);
      return response.view_urls;
    },
    // S3キーが空の場合は実行しない
    enabled: s3Keys.length > 0 && !!apiClient.getIdToken(),
    // Presigned URLは7日間有効なので、キャッシュを長めに設定
    staleTime: 6 * 24 * 60 * 60 * 1000, // 6日間
    gcTime: 7 * 24 * 60 * 60 * 1000, // 7日間 (garbage collection time)
    // エラー時のリトライ設定
    retry: 2,
    retryDelay: 1000,
  });
};

export default usePhotoViewUrls;
